var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((this.getselectedradiobtn()),function(element,key){return _c('v-col',{key:element.variable,attrs:{"cols":"4"}},[_c('Ctrlfinddecay',{attrs:{"title":key,"options":element,"optionsrecomend":element.filter(
          function (a) { return a.TrigmaAI_Recommendation == 'Recommended'; }
        )},on:{"child-method":_vm.updateParent}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }